<template>
    <button class="icon-button"
            :disabled="disabled"
            @click="clickHandler"
    >
        <span class="icon-button__text">
            <slot />
        </span>
    </button>
</template>

<script>
import { DisabledMixin } from './mixins/disabled';

export default {
    mixins: [ DisabledMixin ],
    methods: {
        clickHandler(event) {
            this.$emit('click', event);
        }
    }
}
</script>

<style scoped lang="scss">
    $icon-button-color: $color-black;

    .icon-button {
        position: relative;
        border-radius: 50%;
        border: 0;
        height: 2.5rem;
        width: 2.5rem;
        outline: 0;
        cursor: pointer;
        transition: background-color ease-out .2s;
        background-color: transparent;

        &:hover {
            background-color: rgba($icon-button-color, .1);
        }

        &[disabled] {
            background-color: $color-disabled;
        }
    }

    .icon-button__ripple-container {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .icon-button__text {
        @include icon-font;
        font-size: 2rem;
        line-height: 2.5rem;
        color: $icon-button-color;
        text-align: center;
        width: 100%;
        height: 100%;

        .icon-button[disabled] & {
            color: $color-disabled-contrast;
        }
    }
</style>
